import React, { useEffect, useRef, useState } from "react";
import Layout from "Layout";
import {
  AnimationContainer,
  Head,
  PowerBiContainer,
  Filter,
} from "Views/SSRS/styled.component";

import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import { useSelector } from "react-redux";
import LottieLoader from "react-lottie-loader";

import { Orientation, useOrientation } from "hooks/orientation";
import { Size, useWindowSize } from "hooks/windowSize";
import FilterComponent from "Views/SSRS/Components/FilterComponent";

import { getPowerBIPremiumEmbed } from "../services/powerbiPremium.service";

import * as powerbi from "powerbi-client";
import { models } from "powerbi-client";

type Props = {
  reporte: {
    idWorkspace: string;
    idReport: string;
    name: string;
    parameters: any;
  };
};

export const PowerBIPremiumReport = ({ reporte }: Props) => {
  const reportContainerRef = useRef<HTMLDivElement>(null);

  const [openfilter, setOpenFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [viewMode, setViewMode] = useState("Normal");

  const [embedUrl, setEmbedUrl] = useState<string | null>(null);
  const [accessToken, setEmbedToken] = useState<string | null>(null);

  const [shouldLoadReport, setShouldLoadReport] = useState(false);
  const [selectedParams, setSelectedParams] = useState<Record<string, any[]>>(
    {},
  );

  const { bannerCatalog, titleReport } = useSelector(
    (state: any) => state.theme,
  );

  const size: Size = useWindowSize();
  const orientation: Orientation = useOrientation();

  const loader = require("../../../data/loader_animation.json");

  const buildPowerBIFilters = () => {
    if (!reporte?.parameters || reporte.parameters.length === 0) return [];

    return reporte.parameters
      .map((param: any) => {
        const selectedValue = selectedParams[param.codigoParametro];

        if (!selectedValue) return null;

        const [table, column] = param.codigoParametro.split("/");
        const valuesArray = selectedValue.map((item: any) => item.value);

        return {
          $schema: "http://powerbi.com/product/schema#basic",
          target: {
            table,
            column,
          },
          operator: "In",
          values: valuesArray,
          filterType: models.FilterType.Basic,
        };
      })
      .filter(Boolean);
  };

  /* VIEW MODE */
  useEffect(() => {
    if (orientation.orientation === 90) {
      setViewMode("MobileLandscape");
    } else if (size.width && size.width < 800) {
      setViewMode("MobilePortrait");
    } else {
      setViewMode("Normal");
    }
  }, [orientation, size]);

  /* GET EMBED INFO */
  useEffect(() => {
    if (!reporte?.idReport || !reporte?.idWorkspace) return;

    setIsLoading(true);

    if (reporte?.parameters && reporte.parameters.length > 0) {
      setOpenFilter(true);
    }

    getPowerBIPremiumEmbed(reporte.idWorkspace, reporte.idReport)
      .then((res) => {
        debugger;
        setEmbedUrl(res.embedUrl);
        setEmbedToken(res.accessToken);
      })
      .finally(() => setIsLoading(false));
  }, [reporte]);

  /* EMBED POWER BI (🔥 AQUÍ ESTÁ LA CLAVE) */
  useEffect(() => {
    if (
      !embedUrl ||
      !accessToken ||
      !reportContainerRef.current ||
      (!shouldLoadReport && reporte?.parameters?.length > 0)
    )
      return;

    const filters = buildPowerBIFilters();

    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory,
    );
    const config: powerbi.IEmbedConfiguration = {
      type: "report",
      tokenType: models.TokenType.Embed,
      accessToken: accessToken,
      embedUrl,
      id: reporte.idReport,
      ...(filters.length > 0 && { filters }), // 🔥 solo si existen
      settings: {
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: true },
        },
      },
    };

    console.log("config", config);
    powerbiService.reset(reportContainerRef.current);
    powerbiService.embed(reportContainerRef.current, config);
  }, [embedUrl, accessToken, reporte, shouldLoadReport]);

  useEffect(() => {
    // Si no hay filtros, cargar automáticamente
    if (!reporte?.parameters || reporte.parameters.length === 0) {
      setShouldLoadReport(true);
    }
  }, [reporte]);

  console.log("info", { embedUrl, accessToken });
  console.log("select", selectedParams);

  return (
    <Layout
      theme={{
        backgroundImage: "none",
        backgroundColor: "#f5f7f7",
      }}
    >
      <Head bg={bannerCatalog}>
        {!isLoading && (
          <>
            <IconButton
              onClick={() => setOpenFilter(!openfilter)}
              style={{ color: "white" }}
            >
              {openfilter ? <CloseIcon /> : <FilterAltIcon />}
            </IconButton>
            <span
              className={titleReport ? "title-report" : "title-report-city"}
            >
              {reporte.name}
            </span>
          </>
        )}
      </Head>

      {isLoading && (
        <AnimationContainer>
          <LottieLoader animationData={loader} className="animation" />
        </AnimationContainer>
      )}

      {/* Contenedor relativo para permitir overlay absoluto del filtro */}
      <div style={{ position: "relative", width: "100%" }}>
        <PowerBiContainer display={isLoading ? "none" : "flex"}>
          <div
            ref={reportContainerRef}
            style={{ width: "100%", height: "100%" }}
          />
        </PowerBiContainer>

        {openfilter && reporte.parameters && reporte.parameters.length > 0 && (
          <Filter
            style={{
              position:
                size.width && size.width < 768 ? "relative" : "absolute",
              left: size.width && size.width < 768 ? undefined : "15px",
              top: size.width && size.width < 768 ? undefined : "8px",
              zIndex: 9999,
              width: size.width && size.width < 768 ? "90vw" : "28vw",
              minWidth: 480,
            }}
          >
            <FilterComponent
              filterName={reporte.name}
              parameters={reporte.parameters}
              setValues={(values: any) => {
                setSelectedParams(values);
              }}
              type="POWERBI_PREMIUM"
              filterValues={selectedParams}
              handleViewReport={() => {
                setShouldLoadReport(false);
                setTimeout(() => {
                  setShouldLoadReport(true);
                }, 0);
                setOpenFilter(false);
              }}
            />
          </Filter>
        )}
      </div>
    </Layout>
  );
};
